<template>
  <div
    class="app-container"
    v-if="showSwiper"
    :style="{ backgroundColor: moduleData.backgroundColorValue }"
  >
    <!---->
    <div class="swiper">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in moduleData.groupGif" :key="index">
          <img :src="item" alt="" />
        </swiper-slide>
      </swiper>
      <div
        class="swiper-pagination"
        id="gif-pagination"
        slot="pagination"
      ></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
    <div class="text-wrap">
      <p class="title  h2-vw">{{ moduleData.topicTitle }}</p>
      <p class="desc  h4-vw" style="margin-top:10px;">
        {{ moduleData.bottomDes }}
      </p>
    </div>
  </div>
</template>

<script>
//导入swiper
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "gifPlayer",
  props: {
    moduleData: {
      type: Object,
    },
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        autoplay: false,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        pagination: {
          el: "#gif-pagination",
          clickable: true,
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    showSwiper: function() {
      const groupGif = this.moduleData.groupGif.filter((item) => {
        return item != "";
      });
      console.log("groupGifgroupGif", groupGif);
      return groupGif.length;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
@include setThemeClass {
  .app-container {
    // margin-top: 40px;
    // padding: 3.90625vw 0 3.90625vw;
    padding: 60px 0;
    img {
      width: 100%;
    }
    .swiper-pagination-bullets {
      left: 50%;
      bottom: 0;
      width: 100%;
      transform: translate(-50%, -50%);
      ::v-deep .swiper-pagination-bullet {
        width: 100px;
        height: 2px;
        margin: 0;
        display: inline-block;
        border-radius: 0;
        margin-right: 3px;
      }
    }
    .swiper {
      width: 100%;
      // height: 500px;
      position: relative;
      .swiper-container {
        // width: 80%;
        width: 63vw;
        @include media(
          (
            $home-bg: (
              width: 63vw,
            ),
            $home-md: (
              width: 80vw,
            ),
            $home-sm: (
              width: 100%,
            ),
          )
        );
        // height: 500px;
        .swiper-slide {
          width: 100%;
          //  height: 500px;
          padding-bottom: 40px;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          // img{
          //   width: 100%;
          // }
        }
        // ::v-deep .swiper-pagination-bullet {
        //   width: 100px;
        //   height: 2px;
        //   display: inline-block;
        //   border-radius: 0;
        //   @include media(
        //     (
        //       $home-bg: (
        //         width: 100px,
        //         height: 2px,
        //       ),
        //       $home-md: (
        //         width: 100px,
        //         height: 2px,
        //       ),
        //       $home-sm: (
        //         width: 100px,
        //         height: 2px,
        //       ),
        //     )
        //   );
        // }
      }

      .swiper-button-next {
        // right:20px;
        right: 11vw;
        width: 40px;
        height: 40px;
        background: rgba(24, 26, 36, 0.3)
          url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164317608-icon_common_arrows_24_rig_white@3x.png)
          no-repeat 2px center/24px 24px;
        &:hover {
          background-color: rgba(24, 26, 36, 0.8);
        }
        @include media(
          (
            $home-bg: (),
            $home-md: (
              right: 0px,
            ),
            $home-sm: (
              display: none,
            ),
          )
        );
      }
      .swiper-button-prev {
        // left:20px;
        left: 11vw;
        width: 40px;
        height: 40px;
        background: rgba(24, 26, 36, 0.3)
          url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210623164314543-icon_common_arrows_24_lef_white@3x.png)
          no-repeat 12px center/24px 24px;
        &:hover {
          background-color: rgba(24, 26, 36, 0.8);
        }
        @include media(
          (
            $home-bg: (),
            $home-md: (
              left: 0px,
            ),
            $home-sm: (
              display: none,
            ),
          )
        );
      }
    }
    .text-wrap {
      // margin-top: 30px;
      p {
        margin: 0;
        text-align: center;
        line-height: 1.5;
        &.title {
          // font-size: 1.40625vw;
          // font-weight: 700;
          // color: #131415;
          line-height: 2.509375vw;
          @include media(
            (
              $home-bg: (),
              $home-md: (
                font-size: 28px,
                line-height: 42px,
              ),
              $home-sm: (
                font-size: 28px,
                line-height: 42px,
              ),
            )
          );
        }
        &.desc {
          padding: 0 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
